import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import styled from 'styled-components';
import { Box } from '../Box/Box.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children"];
var StyledCard = styled(Box).withConfig({
  displayName: "Card__StyledCard",
  componentId: "sc-qn6r2n-0"
})(["&&{margin:0;max-height:'inherit';}"]);
var Card = /*#__PURE__*/React.forwardRef(function Card2(props, ref) {
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/jsx(StyledCard, _objectSpread(_objectSpread({}, rest), {}, {
    borderRadius: 2,
    elevation: 1,
    elevationHover: 2,
    padding: 2,
    ref: ref,
    children: children
  }));
});
Card.displayName = "Card";

export { Card };
